import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid } from '@mui/material';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';

interface IProps {
    partialTicket: IPartialTicket

    onClose: (reloadTicket: boolean) => void
}

interface IPartialTicket {
    ticketId: string
    title: string
}

let EditTicket = ({ partialTicket, onClose }: IProps) => {
    let { formatMessage } = useIntl();
    let { enqueueSnackbar } = useSnackbar();

    let [isSaving, setSaving] = useState<boolean>(false);
    let [ticket, setTicket] = useState<IPartialTicket>({} as IPartialTicket);

    useEffect(() => {
        setTicket({ ...partialTicket })
    }, [partialTicket]);


    let handleChangeTitle = (value: string) => {
        setTicket({
            ...ticket,
            title: value
        });
    }

    let closeAndConfirm = async () => {
        try {
            setSaving(true);

            let request = {
                ...ticket
            }

            let res = await axios.post('/api/CustomerTicket/UpdateTicketTitle', request);

            if (res.data.affectedRecords === 1) {
                enqueueSnackbar(formatMessage({ id: LocalizationIds.TicketSaved }), { variant: "success" });// Ticket salvato
                onClose(true);
            }
        } catch (err) { }
        finally {
            setSaving(false);
        }
    }


    return (
        <Dialog open={true} onClose={() => onClose(false)} fullWidth>
            <DialogTitle>
                {formatMessage({ id: LocalizationIds.EditTicketDetails })}
            </DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <TextField
                            label={formatMessage({ id: LocalizationIds.Title })}
                            id="search text"
                            name="title"
                            value={ticket.title}
                            onChange={(e: any) => handleChangeTitle(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} color="secondary" autoFocus>
                    {formatMessage({ id: LocalizationIds.Cancel })}
                </Button>
                <Button
                    onClick={() => closeAndConfirm()}
                    disabled={isSaving === true || ticket == null || ticket.title?.length <= 0}
                    autoFocus
                >
                    {formatMessage({ id: LocalizationIds.Confirm })}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditTicket;